"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import { Component, Ref, Vue } from "vue-property-decorator";
import DistributionDialog from "../../../../components/dialog/DistributionDialog.vue";
import _ from "lodash";
import API from "@ym-framework/api-utils";
import UiGrid, { GridController } from "@/components/grid/UiGrid.vue";
import { APIDataSource } from "@/components/grid/data-source";
import UiDialog from "@/components/dialog/UiDialog.vue";
const gridController = new GridController(
  // new APIDataSource("api://base.auth/api/v7/groups/shop_list")
  // base.auth.pro
  new APIDataSource("api://base.auth.pro/v1/shops")
);
let AccountBindShop = class extends Vue {
  constructor() {
    super(...arguments);
    this.gridController = gridController;
    this.activeName = "first";
    this.selectLock = false;
    this.selectDatas = [];
    this.searchStr = "";
    this.selectedGroup = "";
    this.distribution_group = ["DISTRIBUTED", "UNDISTRIBUTED"];
    this.user_list = [];
    this.new_type = false;
    this.groupList = [];
    this.isSelected = false;
    this.showSelect = false;
    this.user_guid = "";
    this.handleDistributionChange = _.debounce((flag) => __async(this, null, function* () {
      this.isSelected = flag;
      this.gridController.query.current = 1;
      this.updateQueryParams();
      yield this.gridController.search();
    }), 300);
    this.searchByName = _.debounce((searchStr) => {
      this.searchStr = searchStr != null ? searchStr : "";
      this.gridController.query.current = 1;
      this.updateQueryParams();
      this.gridController.search();
    }, 500);
  }
  created() {
    this.gridController.on("searched", (item) => {
      this.checkItem();
    });
    this.gridController.size = true;
    this.gridController.pagePosition = "dialog";
  }
  open(datas) {
    return __async(this, null, function* () {
      this.user_list = datas;
      this.searchStr = "";
      this.selectDatas = [];
      this.selectLock = false;
      this.new_type = false;
      this.groupList = [];
      this.isSelected = false;
      yield this.getGroupList();
      this.gridController.query.current = 1;
      this.updateQueryParams();
      this._distribution_shop.open();
      this._distribution_shop.setBtn(false);
      this._distribution_shop.setOptSpan(18, 6);
      yield this.gridController.search();
      this.$nextTick(() => __async(this, null, function* () {
        if (datas.length === 1) {
          this.user_guid = datas[0].guid;
          this.showSelect = true;
          const result = yield API.get(
            `api://base.auth.pro/v1/user/${datas[0].guid}/auth-shops`
          );
          for (let item of result.data.datas) {
            this._distribution_shop.add({
              id: item.id,
              label: item.name
            });
          }
          this.checkItem();
        }
      }));
    });
  }
  open_new(arr) {
    return __async(this, null, function* () {
      this.user_guid = "";
      this.showSelect = false;
      this.user_list = [];
      this.searchStr = "";
      this.selectDatas = [];
      this.selectLock = false;
      this.new_type = true;
      this.groupList = [];
      yield this.getGroupList();
      this.gridController.query.current = 1;
      this.updateQueryParams();
      this._distribution_shop.open();
      this._distribution_shop.setBtn(false);
      this._distribution_shop.setOptSpan(16, 8);
      yield this.gridController.search();
      this.$nextTick(() => __async(this, null, function* () {
        if (arr && arr.length > 0) {
          for (let item of arr) {
            this._distribution_shop.add({
              id: item.id,
              label: item.label
            });
          }
          this.checkItem();
        }
      }));
    });
  }
  changed(data) {
    this.selectLock = true;
    if (this.new_type === false) {
      let rows = _.differenceWith(
        this.selectDatas,
        data,
        (selectData, data2) => selectData.id == data2.id
      );
      if (rows) {
        for (const row of rows) {
          this._multipleTable.toggleRowSelection(row, false);
        }
      }
    } else {
      let rows = _.differenceWith(
        this.selectDatas,
        data,
        (selectData, data2) => selectData.shopOldId == data2.id
      );
      if (rows) {
        for (const row of rows) {
          this._multipleTable.toggleRowSelection(row, false);
        }
      }
    }
    this.selectLock = false;
  }
  getGroupList() {
    return __async(this, null, function* () {
      try {
        const response = yield API.get(
          "api://base.auth.pro/v1/groups",
          {
            params: {
              type: "SHOP"
            }
          }
        );
        this.groupList = response.data.datas || [];
        const recycleGroup = _.find(this.groupList, {
          id: "shopgroup_system_recycle"
        });
        if (recycleGroup) {
          this.groupList = _.reject(this.groupList, {
            id: "shopgroup_system_recycle"
          });
        }
        if (this.groupList.length > 0) {
          const defaultGroup = this.groupList.find((item) => item.id === this.selectedGroup) || this.groupList[0];
          this.selectedGroup = defaultGroup.id;
        } else {
          this.selectedGroup = "";
        }
      } catch (error) {
        if (error.hasOwnProperty("response")) {
          this.$message.error(error.response.data.errors.datas[0].message);
        }
      }
    });
  }
  changeGroup(groupId) {
    return __async(this, null, function* () {
      this.selectedGroup = groupId;
      this.gridController.query.current = 1;
      this.updateQueryParams();
      yield this.gridController.search();
    });
  }
  gridSort(data) {
    return __async(this, null, function* () {
      this.gridController.query.sort = "sort,desc";
    });
  }
  selectItems(items) {
    this.selectDatas = [];
    this.selectDatas = items;
    if (!this.selectLock) {
      if (this.new_type === false) {
        this._distribution_shop.syncData(
          this.gridController.result.datas,
          items,
          "id",
          "name"
        );
      } else {
        this._distribution_shop.syncData(
          this.gridController.result.datas,
          items,
          "shopOldId",
          "name"
        );
      }
    }
  }
  checkItem() {
    this.selectLock = true;
    if (this._distribution_shop === void 0) {
      return;
    }
    let selectDatas = this._distribution_shop.getAll();
    if (this.new_type === false) {
      let rows = _.intersectionWith(
        this.gridController.result.datas,
        selectDatas,
        (selectData, data) => selectData.id == data.id
      );
      if (rows) {
        for (const row of rows) {
          this._multipleTable.toggleRowSelection(row, true);
        }
      }
    } else {
      let rows = _.intersectionWith(
        this.gridController.result.datas,
        selectDatas,
        (selectData, data) => selectData.shopOldId == data.id
      );
      if (rows) {
        for (const row of rows) {
          this._multipleTable.toggleRowSelection(row, true);
        }
      }
    }
    _.debounce(() => {
      this.selectLock = false;
    }, 600);
  }
  removeAllTooltip() {
    document.querySelectorAll(".el-tooltip__popper").forEach((el) => el.remove());
  }
  saved(data) {
    return __async(this, null, function* () {
      if (this.new_type === false) {
        let _ids = _.map(data, "id");
        let user_ids = _.map(this.user_list, "guid");
        try {
          if (user_ids.length === 1) {
            yield API.post(`api://base.auth.pro/v1/shops-users`, {
              model: "users.auth.shops",
              mode: "COVER",
              shopIds: _ids,
              userIds: user_ids
            });
          }
          if (user_ids.length > 1) {
            yield API.post(`api://base.auth.pro/v1/shops-users`, {
              model: "users.auth.shops",
              mode: "APPEND",
              shopIds: _ids,
              userIds: user_ids
            });
          }
          this.$message.success(
            this.$t("team_management.shop.dialog.success_message")
          );
          this._distribution_shop.close();
          this.$emit("success");
        } catch (error) {
          if (error.hasOwnProperty("response")) {
            this.$message.error(error.response.data.errors.datas[0].message);
          }
        }
      }
      if (this.new_type === true) {
        this.$emit("shops", { datas: data });
        this._distribution_shop.close();
      }
    });
  }
  updateQueryParams() {
    const conditions = [];
    if (this.selectedGroup) {
      conditions.push(`group=="${this.selectedGroup}"`);
    }
    if (this.distribution_group.length === 1) {
      conditions.push(`distribution==${this.distribution_group[0]}`);
    }
    if (this.searchStr) {
      conditions.push(`name=like='${this.searchStr}'`);
    }
    if (this.isSelected) {
      conditions.push(`bindType==NOT_BOUND`);
      conditions.push(`bindUser==${this.user_guid}`);
    }
    this.gridController.query.params = {
      type: "USER_BIND",
      search: conditions.join(";")
    };
  }
};
__decorateClass([
  Ref("distribution-shop")
], AccountBindShop.prototype, "_distribution_shop", 2);
__decorateClass([
  Ref("multipleTable")
], AccountBindShop.prototype, "_multipleTable", 2);
AccountBindShop = __decorateClass([
  Component({
    components: {
      UiDialog,
      UiGrid,
      DistributionDialog
    }
  })
], AccountBindShop);
export {
  AccountBindShop as default
};
